import Vue from 'vue'

let modules = {}
const attributes = ['computed', 'methods']
const requireStore = require.context('.', false, /\w+\.(mixins.js)$/)

requireStore.keys().forEach(fileName => {
  if (fileName !== './index.js') {
    const temp_module = requireStore(fileName).default || requireStore(fileName)
    for (const attr of attributes) {
      modules[attr] = { ...modules[attr], ...temp_module[attr] }
    }
  }
})

Vue.mixin(modules)
